import { api } from "@/builders/axios";
import {
  CourseData,
  EditCourseData,
  FeedbackData,
} from "@/builders/types/course";

const get = function (id: number) {
  return api
    .get<{
      data: CourseData;
    }>(`courses/${id}`)
    .then(({ data }) => data);
};

const put = function (variables: { id: number; data: EditCourseData }) {
  const { id, data } = variables;
  return api.put<CourseData>(`/courses/${id}`, data).then(({ data }) => data);
};

const del = function (id: number) {
  return api.delete(`/courses/${id}`);
};

const rating = function (id: number) {
  return api
    .get<{
      title: string;
    }>(`courses/${id}/rating`)
    .then(({ data }) => data);
};

function enroll(id: number) {
  return api
    .post<{ message: string }>(`courses/${id}/enroll`)
    .then(({ data }) => data);
}

function add_to_wishlist(id: number) {
  return api
    .post<{ message: string }>(`courses/${id}/add-to-wishlist`)
    .then(({ data }) => data);
}

function remove_from_wishlist(id: number) {
  return api
    .delete<{ message: string }>(`courses/${id}/remove-from-wishlist`)
    .then(({ data }) => data);
}

function feedbacks(id: number) {
  return api
    .get<{
      data: FeedbackData[];
    }>(`/courses/${id}/feedbacks`)
    .then(({ data }) => data);
}

export const id = {
  get,
  put,
  del,
  rating,
  enroll,
  add_to_wishlist,
  remove_from_wishlist,
  feedbacks,
};
